import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'templates',
    collectionActionName: 'TEMPLATES',
    itemActionName: 'TEMPLATE',
});
